import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ToastsService } from '@catch/services';
import { TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { SEOService } from '../../../services/seo.service';

@UntilDestroy()
@Component({
  selector: 'app-job-no-interest',
  templateUrl: './job-no-interest.component.html',
  styleUrls: ['./job-no-interest.component.scss'],
  imports: [TranslocoPipe],
})
export class JobNoInterestComponent implements OnInit {
  private readonly jobboardAdapter = inject(JobboardAdapter);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly toastsService = inject(ToastsService);
  private readonly seoService = inject(SEOService);
  private readonly translateService = inject(TranslocoService);

  success: boolean = false;


  ngOnInit(): void {
    const nonce = this.route.snapshot.queryParams['nonce'];
    const jobId = this.route.snapshot.params['jobId'];

    if (!nonce || !jobId) {
      this.toastsService.alert('ct-library.errors.auth.invalid-link');
      this.router.navigate(['/']);
      return;
    }

    this.seoService.updateTitle(
      this.translateService.translate('jobboard.views.job-no-interest.title')
    );
    this.seoService.updateDescription('');

    this.jobboardAdapter
      .noInterestInJob(+jobId, nonce)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.success = true;
        },
        error: () => {
          this.toastsService.alert('ct-library.errors.auth.invalid-link');
          this.router.navigate(['/']);
        },
      });
  }
}

